import { Component, OnInit} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-custom-aimodels',
  templateUrl: './custom-aimodels.component.html',
  styleUrls: ['./custom-aimodels.component.scss']
})
export class CustomAIModelsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('為企業量身打造專屬 AI 模型｜用 Trinka 掌握專屬 AI 優勢');
    this.metaTagService.updateTag({ name: 'description', content: "透過 Trinka AI 為您的企業量身打造專屬的 AI 模型，全面掌控、自主管理，保護您的智慧財產，並善用專有資料提升精準度。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "為企業量身打造專屬 AI 模型｜用 Trinka 掌握專屬 AI 優勢" });
    this.metaTagService.updateTag({ property: 'og:description', content: "透過 Trinka AI 為您的企業量身打造專屬的 AI 模型，全面掌控、自主管理，保護您的智慧財產，並善用專有資料提升精準度。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/enterprise/custom-ai-models/overview' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/enterprise/custom-ai-models/overview' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '為企業量身打造專屬 AI 模型｜用 Trinka 掌握專屬 AI 優勢' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "透過 Trinka AI 為您的企業量身打造專屬的 AI 模型，全面掌控、自主管理，保護您的智慧財產，並善用專有資料提升精準度。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/custom-ai-models/overview' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/custom-ai-models/overview' });

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
    // console.log("Country is", this.country);
  }

}
